"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthersSigner = void 0;
const eth_sig_util_1 = require("@metamask/eth-sig-util");
const common_1 = require("../tools/common");
const BitSigner_1 = require("./BitSigner");
class EthersSigner extends BitSigner_1.BitSigner {
    constructor(signer) {
        super();
        this.signer = signer;
    }
    signTypedData(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, eth_sig_util_1.signTypedData)({
                privateKey: Buffer.from((0, common_1.remove0x)(this.signer.privateKey), 'hex'),
                data,
                version: eth_sig_util_1.SignTypedDataVersion.V4,
            });
        });
    }
}
exports.EthersSigner = EthersSigner;
//# sourceMappingURL=EthersSigner.js.map